import { EpTypographText } from './EpTypographText';
import { EpTypographTitle } from './EpTypographTitle';

/**
 * Typograph component
 */

export const EpTypograph = {
  Title: EpTypographTitle,
  Text: EpTypographText,
};
